import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import LoadingProgress from '@components/LoadingProgress';
import { STEP_TESTS } from '@core/devices/constants/devicesSteps';
import ProgressBarSelection from '../ProgressBarSelection';
import MicrophoneTestProgressBar from './MicrophoneTestProgressBar';
import { useInitMicrophonesDevices } from './hooks';
import { useStyles } from './styles';
import HelperBox from '../HelperBox';

const MicrophoneTest = () => {
  const classes = useStyles();
  const {
    initializing,
    devices,
    activeDeviceId,
    setActiveDeviceId,
    permissionState,
  } = useInitMicrophonesDevices();
  const { t: translate } = useTranslation();

  if (initializing) {
    return <LoadingProgress />;
  }

  return (
    <Box>
      <Box sx={classes.selectionContainer}>
        <MicrophoneTestProgressBar
          activeDeviceId={activeDeviceId}
          permissionState={permissionState}
        />
        <ProgressBarSelection
          devices={devices}
          activeDeviceId={activeDeviceId}
          onDeviceChange={setActiveDeviceId}
          sx={classes.selection}
          typeOfDevice={STEP_TESTS.MICROPHONE}
        />
      </Box>
      <HelperBox
        title={translate('devicesTest.microTest.helper.title')}
        text={translate('devicesTest.microTest.helper.text')}
      />
    </Box>
  );
};

export default MicrophoneTest;
